require('./bootstrap');

window.cl = function (v) { console.log(v); }

window.$window = $(window);
window.$html = $('html');
window.$body = $('body');

window.inview = new Inview();
window.scrollWatcher = new ScrollWatcher();
window.yearSelector = null;



const setNavigationEvents = function () {
	const links = document.getElementsByClassName('nav-main')[0].getElementsByTagName('a');

	for (let link of links) {
		if (!link.href) {
			continue;
		}
		link.addEventListener('click',
			function (event) {
				_gte('click', {
					'event_category': 'Navigation',
					'event_label': this.innerText
				});
			}
		);

	}
}

const setCardEvents = function () {
	const cards = document.getElementsByClassName('cards-with-icons');
	for (let card of cards) {
		for (let link of card.getElementsByClassName('card')) {
			if (!link.href) {
				continue;
			}

			link.addEventListener('click',
				function (event) {
					_gte('click', {
						'event_category': document.title,
						'event_label': this.getElementsByClassName('h2')[0].innerText
					});
				}
			);

		}
	}
}

const setTextImageEvents = function () {
	const blocks = document.getElementsByClassName('text-image');
	for (let block of blocks) {
		for (let link of block.getElementsByClassName('btn')) {
			if (!link.href) {
				continue;
			}

			link.addEventListener('click',
				function (event) {
					_gte('click', {
						'event_category': document.title,
						'event_label': this.innerText
					});
				}
			);

		}
	}
}

const setTextEvents = function () {
	const blocks = document.getElementsByClassName('text-block');
	for (let block of blocks) {
		for (let link of block.getElementsByTagName('a')) {
			if (!link.href) {
				continue;
			}

			link.addEventListener('click',
				function (event) {
					_gte('click', {
						'event_category': document.title,
						'event_label': this.innerText
					});
				}
			);

		}
	}
}
const setComparisonEvents = function () {
	const blocks = document.getElementsByClassName('block-comparison2');
	for (let block of blocks) {
		for (let link of block.getElementsByClassName('btn')) {
			if (!link.href) {
				continue;
			}

			link.addEventListener('click',
				function (event) {
					_gte('click', {
						'event_category': document.title,
						'event_label': this.innerText
					});
				}
			);

		}
	}
}

const setFormBlockEvents = function () {
	const blocks = document.getElementsByClassName('block-form');

	for (let block of blocks) {
		for (let button of block.querySelectorAll('input[type="submit"]')) {
			button.addEventListener('click',
				function (event) {
					_gte('click', {
						'event_category': document.title,
						'event_label': this.value
					});
				}
			);

		}
	}
}
const setFooterEvents = function () {
	let blocks = document.getElementsByClassName('credits');

	for (let block of blocks) {
		for (let link of block.getElementsByTagName('a')) {
			if (!link.href) {
				continue;
			}

			link.addEventListener('click',
				function (event) {
					_gte('click', {
						'event_category': 'Footer',
						'event_label': this.innerText
					});
				}
			);

		}
	}

	blocks = document.getElementsByClassName('newsletter-footer');

	for (let block of blocks) {
		for (let link of block.getElementsByTagName('a')) {
			if (!link.href) {
				continue;
			}

			link.addEventListener('click',
				function (event) {
					_gte('click', {
						'event_category': 'Footer',
						'event_label': this.innerText
					});
				}
			);

		}
	}
}

// dynamic '--vh' css variable for 100% mobile height
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
// window.addEventListener('resize', setVh);
function setVh() {
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh + 'px');
}
setVh();


window.t = function (key, force_lowercase = false, replace = {}) {

	let dictionaries;
	let translation;

	if (window.trans && window.locale) {
		dictionaries = window.trans[window.locale];
	}

	if (dictionaries) {
		translation = dictionaries[key] ? dictionaries[key] : window.trans['en'][key];
		translation = translation ? translation : '';
	}

	for (let key in replace) {
		translation = translation.replace('{' + key + '}', replace[key]);
	}

	return force_lowercase ? translation.toLowerCase() : translation;
}

window.setCookie = function (cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	let expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

window.getCookie = function (cname) {
	let name = cname + "=";
	let ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

window.toggleNav = function () {
	let gteEventAction = 'open';

	if ($html.hasClass('nav-visible')) {
		gteEventAction = 'close';
	}

	_gte(gteEventAction, {
		'event_category': 'Navigation',
		'event_label': gteEventAction + ' menu'
	});

	$html.toggleClass('nav-visible');
	if (!$html.hasClass('nav-visible')) {
		$html.removeClass('language-selector-expanded');
	}
	return false;
}

window.toggleAccount = function (buySoundAfterLogin = null) {

	if (buySoundAfterLogin) {
		localStorage.setItem('buySoundAfterLogin', buySoundAfterLogin);
	} else {
		localStorage.removeItem('buySoundAfterLogin');
	}

	$html.removeClass('nav-visible');
	$html.removeClass('language-selector-expanded');
	$html.toggleClass('account-visible');
	$html.toggleClass('modal-visible');
	return false;
}

window.toggleRegistered = function () {
	$('.modal.registered').hide();
	$html.removeClass('modal-visible');
	return false;
}

window.toggleLanguageSelector = function () {
	$html.toggleClass('language-selector-expanded');
	return false;
}

window.toggleLanguageSelectorFromHeader = function () {
	$html.addClass('language-selector-expanded');
	toggleNav();
	return false;
}



window.videoStart = function (el, muted = false, loop = false, allowFullscreen = true) {
	var $btn = $(el);
	var platform = $btn.data('platform');
	var id = $btn.data('id');
	var html;
	switch (platform) {
		case 'youtube':
			html = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + id + '?autoplay=1' + (loop ? '&playlist=' + id + '&loop=1' : '') + (muted ? '&mute=1' : '') + '&rel=0" frameborder="0" ' + (allowFullscreen ? 'allowfullscreen' : '') + '></iframe>';
			break;

		case 'vimeo':
			html = '<iframe src="https://player.vimeo.com/video/' + id + '?autoplay=1' + (loop ? '&loop=1' : '') + (muted ? '&muted=1' : '') + '" width="100%" height="100%" frameborder="0" ' + (allowFullscreen ? 'webkitallowfullscreen mozallowfullscreen allowfullscreen' : '') + '></iframe>';
			break;

		default:
			return;
	}
	$btn.prev().html(html);
	$btn.hide();

	// add 'is-playing' to videobox
	$btn.closest('.video-box').addClass('is-playing');

	return false;
}

window.inlineVideoStart = function (btn, muted = false, loop = false, allowFullscreen = true, volumeToggle = true) {
	var $btn = $(btn);

	// if not current slide, then scroll to this slide
	var $slide = $btn.closest('.slick-slide');
	if ($slide.length && !$slide.hasClass('slick-current')) {
		$slide.closest('.slick-slider').slick('slickGoTo', $slide.attr('data-slick-index'));
		return false;
	}

	// stop all videos
	$('.video-iframe').html('');
	$('.video-box').removeClass('is-playing').find('.play').show();

	var file = $btn.data('file');
	var subtitles = $btn.data('subtitles');

	const languageNames = new Intl.DisplayNames([window.locale], {
		type: 'language'
	});

	var html = '<video src="/files/' + file + '" autoplay ' + (muted ? ' muted ' : '') + (loop ? ' loop ' : '') + ' playsinline controlsList="nodownload" onclick="return toggleInlineVideoPause(this, \'' + file + '\');">' + (subtitles ? '<track id="subtitles" label="'+languageNames.of(window.locale).charAt(0).toUpperCase() + languageNames.of(window.locale).slice(1) +'" kind="subtitles" srclang="'+window.locale+'" src="/files/' + subtitles + '" default>' : '') + '</video>';
	html += '<div class="pause-indicator"></div>';

	if (allowFullscreen) {
		html += '<a class="fullscreen-toggle" href="#" onclick="return toggleVideoFullscreen(this);"><img src="/images/video-fullscreen.svg" alt="Fullscreen"></a>';
	}

	if (subtitles) {
		html += '<a class="caption-toggle" href="#" onclick="return toggleCaption(this);"><img src="/images/caption-on.svg" alt="Caption"></a>';
	}

	if (volumeToggle) {
		var img = muted ? '/images/volume-mute.svg' : '/images/volume.svg';
		html += '<a class="volume-toggle" href="#" onclick="return toggleVideoVolume(this);"><img src="' + img + '" alt="Fullscreen"></a>';
	}


	$btn.prev().html(html);
	$btn.hide();

	// add 'is-playing' to videobox
	$btn.closest('.video-box').addClass('is-playing');

	if (typeof _gte != 'undefined') {
		_gte('video', {
			'event_category': document.title,
			'event_label': 'play - ' + file,
		});
	}

	if(subtitles) {
		var video = $btn.closest('.video-box').find('video')[0];
		const track = video.textTracks[0];
		video.textTracks[0].mode = 'showing';

		track.addEventListener('cuechange', onCueChange);

		function onCueChange(event) {
			const cues = event.currentTarget.cues;
			for (let i = 0; i < cues.length; i++) {
				cues[i].line = -4;
			}
		}
	}

	$('.video-iframe video').bind("timeupdate", function () {
		const percentage = (this.currentTime / this.duration) * 100;

		if (!this.dataset.percentage) {
			this.dataset.percentage = 0;
		}

		let sendPercentage = false;

		if (percentage >= 25 && this.dataset.percentage < 25) {
			this.dataset.percentage = 25;
			sendPercentage = 25;
		} else if (percentage >= 50 && this.dataset.percentage < 50) {
			this.dataset.percentage = 50;
			sendPercentage = 50;
		} else if (percentage >= 75 && this.dataset.percentage < 75) {
			this.dataset.percentage = 75;
			sendPercentage = 75;
		} else if (percentage >= 100 && this.dataset.percentage < 100) {
			this.dataset.percentage = 100;
			sendPercentage = 100;

			$('.video-iframe').html('');
			$('.video-box').removeClass('is-playing').find('.play').show();
		}

		if (sendPercentage) {
			if (typeof _gte != 'undefined') {
				_gte('video', {
					'event_category': document.title,
					'event_label': sendPercentage + '% - ' + file,
				});
			}
		}
	});

	return false;
}

var inlineAutoplayElements = document.querySelectorAll('.inline-autoplay');

inlineAutoplayElements.forEach(function (inlineAutoplayElement) {
	let muted = inlineAutoplayElement.classList.contains('muted');
	let loop = inlineAutoplayElement.classList.contains('loop-enabled');
	let allowfullscreen = inlineAutoplayElement.classList.contains('allowfullscreen');
	let displayVolumeToggle = inlineAutoplayElement.classList.contains('display-volume-toggle');
	window.inlineVideoStart(inlineAutoplayElement, muted, loop, allowfullscreen, displayVolumeToggle);
});

var autoplayElements = document.querySelectorAll('.autoplay');

autoplayElements.forEach(function (autoplayElement) {
	let muted = autoplayElement.classList.contains('muted');
	let loop = autoplayElement.classList.contains('loop-enabled');
	let allowfullscreen = autoplayElement.classList.contains('allowfullscreen');

	window.videoStart(autoplayElement, muted, loop, allowfullscreen);
});

window.toggleVideoFullscreen = function (btn) {
	var $btn = $(btn);
	var video = $btn.closest('.video-box').find('video')[0];

	// make full screen
	if (video.requestFullscreen)
		video.requestFullscreen();
	else if (video.webkitRequestFullscreen)
		video.webkitRequestFullscreen();
	else if (video.webkitEnterFullscreen)
		video.webkitEnterFullscreen();
	else if (video.enterFullscreen)
		video.enterFullscreen();
	else if (video.msRequestFullScreen)
		video.msRequestFullScreen();

	return false;
}

window.toggleVideoVolume = function (btn) {
	var $btn = $(btn);
	var video = $btn.closest('.video-box').find('video')[0];
	var logo = btn.firstElementChild;

	if (video.muted) {
		video.muted = false;
		logo.src = '/images/volume.svg'
	}
	else {
		video.muted = true;
		logo.src = '/images/volume-mute.svg'
	}
	// 	video.webkitRequestFullscreen();
	// else if (video.webkitEnterFullscreen)
	// 	video.webkitEnterFullscreen();
	// else if (video.enterFullscreen)
	// 	video.enterFullscreen();
	// else if (video.msRequestFullScreen)
	// 	video.msRequestFullScreen();

	return false;
}

window.toggleCaption = function (btn) {
	var $btn = $(btn);
	var video = $btn.closest('.video-box').find('video')[0];
	var logo = btn.firstElementChild;

	console.log(video.textTracks[0].mode);
	if (video.textTracks[0].mode === 'showing') {
		logo.src = '/images/caption-off.svg';
		video.textTracks[0].mode = 'disabled';
	} else {
		logo.src = '/images/caption-on.svg';
		video.textTracks[0].mode = 'showing';
	}

	return false;
}

window.toggleInlineVideoPause = function (video, file) {
	// if fullscreen, then ignore this
	if (document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen) {
		return false;
	}

	if (video.paused) {
		video.play();
		video.classList.remove('is-paused');

		_gte('video', {
			'event_category': document.title,
			'event_label': 'play - ' + file,
		});
	} else {
		video.pause();
		video.classList.add('is-paused');

		_gte('video', {
			'event_category': document.title,
			'event_label': 'stop - ' + file,
		});
	}

	return false;
}

window.initSliders = function () {
	$('.slides').slick({
		dots: $('.slides').hasClass('with-dots'),
		arrows: true,
		infinite: true,
		centerMode: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		variableWidth: true,
		centerPadding: '60px',
	}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {

		// reset all videos
		$('.slides video').remove();
		$('.slides .fullscreen-toggle').remove();
		$('.slides .play').show();
		$('.slides .video-box').removeClass('is-playing');

		// align year selector
		if (window.yearSelector) {
			window.yearSelector.setYearBySlideIndex(nextSlide);
		}
	});

	if ($('.year-selector').length) {
		window.yearSelector = new YearSelector($('.year-selector'));
	}
}

window.scrollSlider = function (dir) {
	if (dir > 0) {
		$('.slides').slick('slickNext');
	} else {
		$('.slides').slick('slickPrev');
	}
	return false;
}

window.clickReadMore = function (el) {
	var section = $(el).closest('section').next();
	var sectionY = section[0].getBoundingClientRect().y;
	var windowY = window.scrollY;
	var headerHeight = $('section.header').height();
	$('html, body').animate({ scrollTop: windowY + sectionY - headerHeight }, 700);
	return false;
}

window.isMobile = function () {
	return window.innerWidth <= 500;
}

window.dataLayer = window.dataLayer || [];
dataLayer.push({ 'domain': window.location.hostname });

window._gte = function (eventName, data = {}) {
	if ('ga' in window && typeof window.ga.getAll !== "undefined") {
		var tracker = window.ga.getAll()[0];
		if (tracker) {
			for (let dataKey in data) {
				tracker.send('event', eventName, dataKey, data[dataKey]);

			}
		}
	}
}

window.Vue = require("vue").default;
import VueRouter from 'vue-router';

Vue.use(VueRouter);

window.router = new VueRouter({
	mode: 'history',
});

Vue.component('play-button', require('./components/PlayButton.vue').default);
Vue.component('jinglebox', require('./components/Jinglebox.vue').default);
Vue.component('jinglebox-toggle', require('./components/JingleboxToggle.vue').default);
Vue.component('sounds', require('./components/Sounds.vue').default);
Vue.component('player', require('./components/Player.vue').default);
Vue.component('audio-recorder', require('./components/Recorder.vue').default);
Vue.component('showcase-overview', require('./components/Blocks/Showcases.vue').default);
Vue.component('starter-sets', require('./components/StarterSets.vue').default);
Vue.component('auth-modal', require('./components/AuthModal.vue').default);
Vue.component('account-modal', require('./components/AccountModal.vue').default);
Vue.component('audio-uploader', require('./components/AudioUploader.vue').default);
Vue.component('subscription', require('./components/Subscription.vue').default);
Vue.component('audio-element', require('./components/AudioElement.vue').default);
Vue.component('website-assistant', require('./components/WebsiteAssistent.vue').default);
Vue.component('header-button', require('./components/HeaderButton.vue').default);
Vue.component('visuals', require('./components/Visuals.vue').default);

window.app = new Vue({
	el: '#app',
	router
});



// temporary, will go into checkout Vue component
window.checkoutStepTMP = function (dir) {
	var $steps = $('section.checkout .step');
	var currentStep = $('section.checkout .step.on').index();

	currentStep += dir;
	if (currentStep > $steps.length) {
		currentStep = $steps.length;
	}
	if (currentStep < 0) {
		currentStep = 0;
	}

	// set class
	$('section.checkout .step:eq(' + currentStep + ')').addClass('on').siblings().removeClass('on');
}


window.initLottieCards = function () {
	if (window.isMobile()) {

		// play all cards
		$('.card.with-lottie').each(function () {
			var player = $(this).find('lottie-player');
			if (player.length) {
				player[0].play();
			}
		});
	}
	else {
		// play on hover
		$('.card.with-lottie').on('mouseover', function () {
			var player = $(this).find('lottie-player');
			if (player.length) {
				player[0].play();
				player[0].setLooping(true);
			}
			return false;
		}).on('mouseleave', function () {
			var player = $(this).find('lottie-player');
			if (player.length) {
				player[0].play();
				player[0].setLooping(false);
			}
			return false;
		});

	}

}

window.startInlineLotties = function () {
	$('lottie-player.inline').each(function () {
		this.play();
	});
}

//-------------------------
// New Cookie Bot
//-------------------------
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Setup GTM dataLayer -- load
if (document.getElementsByClassName('js-cookiebar').length > 0) { // Cookie Bar Block is present on the page

	// see if cookie exists, if not show cookiebar -- recommended to do this in head of page
	if (!getCookie("PureCookieConsent")) {
		document.getElementsByClassName("js-cookiebar")[0].style.display = "block";
		window.dataLayer = [{
			'event': 'NoCookieExist'
		}];
	} else {
		var cookieValue = JSON.stringify({
			cookieValue: getCookie("PureCookieConsent")
		});
		var jsonData = JSON.parse(cookieValue);
		pushCookieValueToDataLayer(jsonData.cookieValue, "CookieBarStatus", false);
	}

	// get Cookie by name - credits to stackoverflow
	function getCookie(cname) {
		var name = cname + "=",
			decodedCookie = decodeURIComponent(document.cookie),
			ca = decodedCookie.split(";");

		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == " ") {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}

	// push cookieValue to dataLayer - set array, set eventName
	function pushCookieValueToDataLayer(arr, eventName, boolean) {
		if(typeof arr === 'string') {
			arr = JSON.parse(arr);
		}
		var x = arr.filter(function (v) {
			return v.value === true;
		});

		dataLayerType(x, eventName, boolean);
	}

	function dataLayerType(x, e, b) {
		if (b) {
			for (var i = 0; i < x.length; i++) {
				window.dataLayer.push(_defineProperty({}, x[i].name, x[i].value));
			}
			window.dataLayer.push({
				'event': e
			});
		} else {
			var dataInit = [];
			for (var i = 0; i < x.length; i++) {
				dataInit.push(_defineProperty({}, x[i].name, x[i].value));
			};
			dataInit.push({
				'event': e
			});
			window.dataLayer = dataInit;
		}
	}

	// set cookie on click
	window.onCookieButtonClick = function () {
		var basicValue = document.getElementById("basic_chkbx").checked,
			preferencesValue = document.getElementById("preferences_chkbx").checked,
			statisticsValue = document.getElementById("statistics_chkbx").checked,
			marketingValue = document.getElementById("marketing_chkbx").checked,
			options = [
				{ name: "basic", value: basicValue },
				{ name: "preferences", value: preferencesValue },
				{ name: "statistics", value: statisticsValue },
				{ name: "marketing", value: marketingValue }
			],
			data = JSON.stringify(options);


		// set cookie
		window.setCookie("PureCookieConsent", data, 3650)
		pushCookieValueToDataLayer(options, "CookiePreferencesChange", true);
		document.getElementsByClassName("js-cookiebar")[0].style.display = "none";
	}

	window.showCustomization = function () {
		document.documentElement.classList.toggle('cookie-customization-visible');
		return false;
	}
}

window.onContactSend = function (token) {
	const form = document.getElementById('contact-form');

	form.submit();
};

window.onWebinarSubscribe = function () {
	return document.getElementById('webinarForm').submit();
}
window.onNewsletterSubscribe = function () {
	return document.getElementById('newsletterForm').submit();
}


// lottie logo animation
function initLottieLogo() {
	let lottieLogoActions;
	if (document.querySelector('.logo.animated').classList.contains('skip-intro')) {
		lottieLogoActions = [
			{
				state: 'stop',
				transition: 'hover',
				frames: [80]
			},
			{
				state: 'autoplay',
				transition: 'onComplete',
				frames: [80, 120]
			},
			{
				state: 'autoplay',
				transition: 'onComplete',
				frames: [35, 80],
				jumpTo: 1
			},
		];
	} else {
		lottieLogoActions = [
			{
				state: 'autoplay',
				transition: 'onComplete',
				frames: [0, 80]
			},
			{
				state: 'stop',
				transition: 'hover',
				frames: [80]
			},
			{
				state: 'autoplay',
				transition: 'onComplete',
				frames: [80, 120]
			},
			{
				state: 'autoplay',
				transition: 'onComplete',
				frames: [35, 80],
				jumpTo: 1
			},
		];
	}

	let LottieInteractivity = require('@lottiefiles/lottie-interactivity');
	LottieInteractivity.create({
		player: '#lottie-logo',
		mode: "chain",
		actions: lottieLogoActions,
	});
}

function checkUserLanguage() {
	if (!window.checkForNavigatorLanguage || !window.checkForNavigatorLanguages) {
		return;
	}

	var lang = window.navigator.language || window.navigator.userLanguage;
	if (!lang) {
		return;
	}

	var lang = lang.substr(0, 2).toLowerCase();

	for (var i in window.checkForNavigatorLanguages) {
		var checkLang = i.substr(0, 2).toLowerCase();

		if (checkLang == window.checkForNavigatorCurrentLang) {
			continue;
		}

		if (checkLang != lang) {
			continue;
		}

		var redirect_url = new URL(window.checkForNavigatorLanguages[i]);

		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);

		const entries = urlParams.entries();

		for (const entry of entries) {
			redirect_url.searchParams.append(entry[0], entry[1]);
		}

		window.location.href = redirect_url.toString();
		return;
	}
}
checkUserLanguage();

$(document).ready(function () {

	if ($('.rellax').length) {
		setTimeout(function () {
			window.rellax = new Rellax('.rellax');
		}, 500);
	}

	initSliders();
	initLottieCards();
	startInlineLotties();
	// initLottieLogo();

	setVh();

	setNavigationEvents();
	setCardEvents();
	setTextImageEvents();
	setTextEvents();
	setComparisonEvents();
	setFormBlockEvents();
	setFooterEvents();

	$(window).on('scroll', function () {
		const s = $(window).scrollTop(),
			d = $(document).height(),
			c = $(window).height();

		const percentage = (s / (d - c)) * 100;


		if (!document.body.dataset.scroll_percentage) {
			document.body.dataset.scroll_percentage = 0;
		}


		let sendPercentage = false;

		if (percentage >= 25 && document.body.dataset.scroll_percentage < 25) {
			document.body.dataset.scroll_percentage = 25;
			sendPercentage = 25;
		} else if (percentage >= 50 && document.body.dataset.scroll_percentage < 50) {
			document.body.dataset.scroll_percentage = 50;
			sendPercentage = 50;
		} else if (percentage >= 75 && document.body.dataset.scroll_percentage < 75) {
			document.body.dataset.scroll_percentage = 75;
			sendPercentage = 75;
		} else if (percentage >= 100 && document.body.dataset.scroll_percentage < 100) {
			document.body.dataset.scroll_percentage = 100;
			sendPercentage = 100;
		}

		if (sendPercentage) {
			_gte('scroll', {
				'event_category': document.title,
				'event_label': sendPercentage + '%',
			});
		}
	})
});